import { render, staticRenderFns } from "./RatingStars.vue?vue&type=template&id=012e5411&"
import script from "./RatingStars.vue?vue&type=script&lang=js&"
export * from "./RatingStars.vue?vue&type=script&lang=js&"
import style0 from "./RatingStars.vue?vue&type=style&index=0&id=012e5411&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports